import React, { Component, useEffect, useState } from "react";
import { connect } from "react-redux";
import * as configActions from "../../store/action/config";
import * as postActions from "../../store/action/post";
import * as _ from "lodash";
import localStorage from "../../utils/local-storage";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ExampleCustomInput } from "./action/draft";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { OverlayTrigger, Popover } from "react-bootstrap";
import RequireChecklist from "src/components/posts/tab/require-checklist";
import ScreenSize from "src/services/screenSize";
import PostService from "../../services/PostService";
import { udpateLogPost } from "../../utils/common"
import moment from 'moment';
import Button from "react-bootstrap/Button";
import { confirm } from 'src/utils/confirm';
import { checkCanPublish, checkCanEditPublish, checkCanTakedown } from 'src/utils/checkPublishPermission';
import { getHome } from "../../page/home/utils/helper";
import validPRPublishedAt from "src/utils/validPRPublishedAt";
import ButtonAi from "./page-list-posts/ButtonAi";
import countWordsHTML from 'src/utils/countWordsHTML';
import localStore from 'src/utils/local-storage';


const DebouncedButton = ({ as = Button, delay = 1000, onClick, ...props }) => {
  const [isDisabled, setDisabled] = useState(false);

  useEffect(() => {
    if (!isDisabled) {
      // timeout elapsed, nothing to do
      return;
    }

    // isDisabled was changed to true, set back to false after `delay`
    const handle = setTimeout(() => {
      setDisabled(false);
    }, delay);
    return () => clearTimeout(handle);
  }, [isDisabled, delay]);

  const handleClick = (e) => {
    if (isDisabled) {
      return;
    }

    setDisabled(true);
    if(onClick){
      return onClick(e);
    }
    return;
  };

  const Component = as;
  return <Component {...props} disabled={isDisabled} onClick={handleClick} />;
};


class ActionsPost extends Component {
  isMobile = false;
  
  constructor() {
    super();
    const aiLimitWords = localStore.get("_aiLimitWord");
    this.state = {
      valueInput: "",
      onHover: false,
      updateStatus: false,
      startDate: null,
      scheduledPost: false,
      aiLimitWords: (aiLimitWords && aiLimitWords.content) ? aiLimitWords.content : 200,
      clickingButton: false,
    };

    this.isMobile = ScreenSize.isMobile;
  }

  componentDidMount() {
    if (this.props.scheduleDate) {
      this.setState({ scheduledPost: true });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { post: nextPost, listTab, checkExternalIMGError: nextCheckExternalIMGError } = nextProps;
    const { listTab: prevListTab, checkExternalIMGError: prevCheckExternalIMGError } = this.props;
    if (nextPost.updatePostStatus === 2 && this.state.updateStatus) {
      window.location.href = "/posts";
    }
    this.setState({ listTab });
    if(nextCheckExternalIMGError !== prevCheckExternalIMGError) this.setState({clickingButton: nextCheckExternalIMGError});
  }

  confirmAction(dataUpdate) {
    // type
    // warning - cho phép thực hiện tiếp thao tác
    // error - không cho thực hiện tiếp thao tác
    const type = dataUpdate.type ? dataUpdate.type : "warning";
    const options = {
      title: "Title",
      message: "Message",
      buttons: [
        {
          label: "Yes",
          onClick: () => alert("Click Yes")
        },
        {
          label: "No",
          onClick: () => alert("Click No")
        }
      ],
      childrenElement: () => <div />,
      customUI: ({ onClose }) => (
        <div className="custom-ui-alert">
          <h1 dangerouslySetInnerHTML={{__html: dataUpdate.message}}></h1>
          {dataUpdate.messageSecond &&
            <div className="text-left" dangerouslySetInnerHTML={{__html: dataUpdate.messageSecond}}>
            </div>
          }
          {type == "warning" &&
            <div className="box">
              <div className="bg-d9534f" onClick={() => {
                onClose();
                  this.setState({clickingButton: false});
                }}>
                Không, cần xem lại
              </div>
              <div
                className="bg-c7c6c5"
                onClick={() => {
                  this.actionSendButton(dataUpdate);
                  onClose();
                }}
              >
                Có, tiếp tục
              </div>
            </div>
          }
          {type == "error" &&
            <div className="box">
              <div className="bg-d9534f w-100" onClick={() => {onClose(); this.setState({clickingButton: false});}}>
                <span dangerouslySetInnerHTML={{__html: dataUpdate.messageConfirm ? dataUpdate.messageConfirm : dataUpdate.message }}></span>
              </div>
            </div>
          }
        </div>
      ),
      closeOnEscape: true,
      closeOnClickOutside: true,
      willUnmount: () => { },
      onClickOutside: () => { },
      onKeypressEscape: () => { }
    };
    // console.log(options);
    confirmAlert(options);
  }

  actionBeforeConfirm(type, text = 'Bạn thực hiện thao tác ?') {
    const options = {
      title: "Title",
      message: "Message",
      buttons: [
        {
          label: "Yes",
          onClick: () => alert("Click Yes")
        },
        {
          label: "No",
          onClick: () => alert("Click No")
        }
      ],
      childrenElement: () => <div />,
      customUI: ({ onClose }) => (
        <div className="custom-ui-alert">
          <h1 dangerouslySetInnerHTML={{__html: text}}></h1>
          <div className="box">
            <div className="bg-d9534f" onClick={() => {onClose(); this.setState({clickingButton: false});}}>
              Không, cần xem lại
            </div>
            <div
              className="bg-c7c6c5"
              onClick={() => {
                this.savePost(type);
                onClose();
              }}
            >
              Có, tiếp tục
            </div>
          </div>
        </div>
      ),
      closeOnEscape: false,
      closeOnClickOutside: false
    };

    confirmAlert(options);
  }

  async savePost(status) {
    console.log("savePost", this.state.clickingButton);
    if (this.state.clickingButton) {
      return;
    }
    if(this.props.setShowExitPrompt){
      this.props.setShowExitPrompt(false);
    }
    const _user = localStorage.get("_user");
    const {
      post: { currentPost },
      config: { listPosttyle }
    } = this.props;
    // macdinh la check condition
    let should_check_condition = "yes";
    let message = "Bạn thực hiện thao tác ?";
    let homeCheckIndex = -1;
    let type = "warning";
    let messageConfirm, messageSecond;
    const currentPostType = currentPost.posttype.type_code;
    //neu bai post da dang => co 2 action (go xuong  = waiting, bo rac = trash) => khong can xet dieu kien
    if (currentPost.posttype.type_code == "ready") {
      //check bài có được set home không?
      const home = await getHome();
      if(status != "ready" && home && 
        (
          home.tiles.find((element, index) => { if(element.post._id === currentPost._id && element.type === "manual"){
            homeCheckIndex = index;
            return element;
          }})
        )
        ||
        ( 
          home.tiles.find((element, index) => { 
            if(element.nextPost && element.nextPost._id === currentPost._id && element.type === "manual"){
            homeCheckIndex = index;
            return element;
          }})
        )
        
      ){
        // console.log('Check home index '+ homeCheckIndex);
        if(homeCheckIndex >= 0){
          should_check_condition = "no";
          message = `Bạn thực hiện thao tác hạ bài đang được set trang chủ vị trí ${homeCheckIndex + 1} ?`;
          type = "error";
          messageConfirm = "Vui lòng set trang chủ lại.";
        }
      }
      else{
        should_check_condition = "yes";
      }
    }
    // neu bai post dang review => 1 action (tra bai viet = draft )=> khong can xet dieu kien
    // neu bai post dang review => 2 action (len lich, dang bai )=> can xet dieu kien
    if (currentPost.posttype.type_code == "waiting") {
      if (status == "draft") {
        should_check_condition = "no";
        message = "Bạn thực hiện thao tác hạ bài chờ duyệt ?";
      }
      // if (status == "ready") {
      //   should_check_condition = "yes"
      // }
    }
    //khong check dieu kien tu draft xuong trash
    if (currentPost.posttype.type_code == "draft") {
      if (status == "trash") {
        should_check_condition = "no";
        message = "Bạn thực hiện thao tác bỏ rác bài nháp ?";
      }
    }

    if (currentPost.posttype.type_code == "draft" && status == "draft") {
      this.setState({clickingButton: false});
    } else {
      if (!currentPost.is_live) {
        this.setState({clickingButton: true});
      }
    }
    //check trùng lịch PR đăng bài ngay
    if(currentPost.pr_type && currentPost.pr_type != "0" && status == "ready"){
      const timePR = currentPost.publishedAt ? currentPost.publishedAt : (currentPost.scheduleAt ? currentPost.scheduleAt : new Date());
      const validPR = await validPRPublishedAt(currentPost.pr_type, timePR, listPosttyle, currentPost);
      if(validPR && validPR.type == "error"){
        should_check_condition = validPR.should_check_condition;
        message = validPR.message;
        type = validPR.type;
        messageConfirm = validPR.messageConfirm;
        messageSecond = validPR.messageSecond;
      }
    }
    //check trùng lịch PR lên lịch

    if(currentPost.pr_type && currentPost.pr_type != "0" && status == "schedule"){
      const timePR = currentPost.scheduleAt ? currentPost.scheduleAt : new Date();
      const validPR = await validPRPublishedAt(currentPost.pr_type, timePR, listPosttyle, currentPost);
      if(validPR && validPR.type == "error"){
        should_check_condition = validPR.should_check_condition;
        message = validPR.message;
        type = validPR.type;
        messageConfirm = validPR.messageConfirm;
        messageSecond = validPR.messageSecond;
      }
    }

    const posttype = _.find(listPosttyle, { type_code: status });
    const dataUpdate = {
      posttype: posttype,
      should_check_condition,
      currentPostType,
      message: message,
      type,
      messageConfirm,
      messageSecond,
    };
    this.actionBeforeSendButton(dataUpdate);
  }

  setStartDate(date) {
    const {
      post: { currentPost },
      config: { listPosttyle }
    } = this.props;
    let should_check_condition = "yes";
    const posttype = _.find(listPosttyle, { type_code: "schedule" });
    if (date > new Date()) {
      const dataUpdate = {
        posttype: posttype,
        time: date,
        should_check_condition: should_check_condition
      };
      this.actionBeforeSendButton(dataUpdate);
    } else {
      toast.error("Chọn ngày lớn hơn hiện tại.");
    }
    this.setState({ startDate: date });
  }

  actionBeforeSendButton(dataUpdate) {
    if (dataUpdate.should_check_condition == "no") {
      // console.log(dataUpdate);
      this.confirmAction(dataUpdate);
    } else {
      // this.generateLogAction(dataUpdate);
      this.actionSendButton(dataUpdate);
    }
  }


  generateLogAction(posttype) {
    // set action post
    const { post: { currentPost } } = this.props;

    let logAction = "";
    if (posttype.type_code == "draft") {
      if (currentPost.posttype.type_code == "draft") {
        logAction = udpateLogPost('lưu nháp');
      } else {
        logAction = udpateLogPost('hạ');
      }
    }
    if (posttype.type_code == "waiting") {
      logAction = udpateLogPost('gửi duyệt');
    }
    if (posttype.type_code == "schedule") {
      let scheduleTime = moment(currentPost.scheduleAt).format('HH:mm DD/MM/YYYY');
      logAction = udpateLogPost(`hẹn giờ ${scheduleTime}`);
    }
    if (posttype.type_code == "ready") {
      logAction = udpateLogPost('đăng');
    }
    if (posttype.type_code == "trash") {
      logAction = udpateLogPost('bỏ rác');
    }
    return logAction;
  }


  actionSendButton(dataUpdate) {
    dataUpdate.new_action = this.generateLogAction(dataUpdate.posttype);
    this.props.handleUpdateStatus(dataUpdate);
  }

  savePreviewPost = () => {
    const { post: { currentPost }, config: { listPosttyle } } = this.props;
    const dataUpdate = {
      posttype: currentPost.posttype.type_code,
      should_check_condition: 'yes'
    };
    PostService.update(currentPost);
    // this.props.handleUpdateStatus(dataUpdate);


  }

  generateAction(status) {
    const _user = localStorage.get("_user");
    const { postdata, scheduleDate } = this.props;
    const canEdit = (postdata.permission && postdata.permission.can_edit) || true;
    // nhap thi bo rac dc
    // co publish thi bo rac
    // tra bai va bo rac ko check condition
    const isDraft = postdata.posttype.type_code === "draft";
    const goPreview = postdata.posttype.type_code === "draft";
    const canTakedown = checkCanTakedown(postdata);
    const canTrash = _user.can_publish || false;
    const canPublish = checkCanPublish(postdata);
    const canEditPublish = checkCanEditPublish(postdata);
    const canReject = _user.can_reject || false;
    console.log("generateAction", status);
    if (status == "draft") {
      return (
        <div className="action-div">
          {canPublish && this.props.condition && scheduleDate && (
            <DebouncedButton
              className={
                "btn btn-custom ml10 bg-f0ad4e " +
                (this.props.condition
                  ? "require-status-success"
                  : "require-status-error")
              }
              onClick={() => (postdata.categories && postdata.categories.length > 1) ? this.actionBeforeConfirm("schedule", "Bài viết có trên 1 chuyên mục. Bạn vẫn thực hiện thao tác ?") : this.savePost("schedule")}
            >
              <i className="fas fa-calendar-day"></i>
              Lên lịch
            </DebouncedButton>
          )}
          {canPublish && this.props.condition && !scheduleDate && (
            <DebouncedButton
              className={
                "btn btn-custom ml10 bg-428bca " +
                (this.props.condition
                  ? "require-status-success"
                  : "require-status-error")
              }
              onClick={() => this._publishPost()}
            >
              <i className="fas fa-external-link-square-alt"></i>
              Đăng bài
            </DebouncedButton>
          )}
          {this.props.condition && countWordsHTML(postdata.content) > this.state.aiLimitWords && (
            <ButtonAi postItem={postdata} className="rounded-1" />
          )}
          {goPreview && this.props.condition && (
            <DebouncedButton
              className={
                "btn btn-custom ml10 bg-12BF6D " +
                (this.props.condition
                  ? "require-status-success"
                  : "require-status-error")
              }
              onClick={() => (postdata.categories && postdata.categories.length > 1) ? this.actionBeforeConfirm("waiting", "Bài viết có trên 1 chuyên mục. Bạn vẫn thực hiện thao tác ?") : this.savePost("waiting")}
            >
              <i className="fas fa-paper-plane"></i>
              Gửi Duyệt
            </DebouncedButton>
          )}

          {isDraft && (
            <DebouncedButton
              className="btn btn-custom ml10 bg-FFA52A"
              onClick={() => (postdata.categories && postdata.categories.length > 1) ? this.actionBeforeConfirm("draft", "Bài viết có trên 1 chuyên mục. Bạn vẫn thực hiện thao tác ?") : this.savePost("draft")}
            >
              <i className="fas fa-save"></i>
              Lưu Nháp
            </DebouncedButton>
          )}
          {canTrash && (
            <DebouncedButton
              className="btn btn-custom ml10"
              onClick={() => this.actionBeforeConfirm("trash", 'Bạn thực hiện thao tác bỏ rác?')}
            >
              Bỏ rác
            </DebouncedButton>
          )}

          {true && (
          <div className="d-flex justify-content-center gap-2 mt-2">
            <DebouncedButton className="btn btn-custom ml10 bg-17a2b8 flex-fill">
              <a
                onClick={this.savePreviewPost}
                href={`/preview/${postdata._id}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fas fa-eye"></i> PC
              </a>
            </DebouncedButton>
            <DebouncedButton className="btn btn-custom ml10 bg-17a2b8 flex-fill">
              <a
                onClick={this.savePreviewPost}
                href={`/preview/${postdata._id}?isMobile=true`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fas fa-eye"></i> Mobile
              </a>
            </DebouncedButton>
          </div>
          )}
        </div>
      );
    } else if (status == "waiting") {
      const dataUpdateTraBaiWaiting = {
        posttype: {
          type_code: "draft",
          _id: "5e80d4c7c38ec834dcbd98d2",
          title: "Nháp",
          color: "#ffffff",
          createdAt: "2020-03-29T17:03:03.004Z",
          updatedAt: "2020-03-29T17:03:03.004Z",
          __v: 0,
          id: "5e80d4c7c38ec834dcbd98d2",
          value: "5e80d4c7c38ec834dcbd98d2"
        }, should_check_condition: "no",
        message: "Bạn thực hiện thao tác trả bài?"
      }
      return (
        <div className="action-div">
          {canPublish && (
            <DebouncedButton
              className="btn btn-custom ml10 bg-d9534f"
              onClick={() => this.confirmAction(dataUpdateTraBaiWaiting)}
            >
              <i className="fas fa-times"></i>
              Trả bài
            </DebouncedButton>
          )}
          {
            this.props.condition && countWordsHTML(postdata.content) > this.state.aiLimitWords && (
              <ButtonAi postItem={postdata} className="rounded-1" />
            )
          }
          {canTrash && (
            <DebouncedButton
              className="btn btn-custom ml10"
              onClick={() => this.actionBeforeConfirm("trash", 'Bạn thực hiện thao tác bỏ rác ?')}
            >
              Bỏ rác
            </DebouncedButton>
          )}
          {canPublish && this.props.condition && scheduleDate && (
            <DebouncedButton
              className={
                "btn btn-custom ml10 bg-f0ad4e " +
                (this.props.condition
                  ? "require-status-success"
                  : "require-status-error")
              }
              onClick={() => this.savePost("schedule")}
            >
              <i className="fas fa-calendar-day"></i>
              Lên lịch
            </DebouncedButton>
          )}

          {(canPublish || canEdit) && (
            <DebouncedButton
              className={
                "btn btn-custom ml10 bg-428bca " +
                (this.props.condition
                  ? "require-status-success"
                  : "require-status-error")
              }
              onClick={() => this.savePost("waiting")}
            >
              <i className="fas fa-external-link-square-alt"></i>
              Lưu
            </DebouncedButton>
          )}

          {canPublish && this.props.condition && !scheduleDate && (
            <DebouncedButton
              className={
                "btn btn-custom ml10 bg-428bca " +
                (this.props.condition
                  ? "require-status-success"
                  : "require-status-error")
              }
              onClick={() => this._publishPost()}
            >
              <i className="fas fa-external-link-square-alt"></i>
              Đăng bài
            </DebouncedButton>
          )}
          {true && (
          <div className="d-flex justify-content-center gap-2 mt-2">
            <DebouncedButton className="btn btn-custom ml10 bg-17a2b8 flex-fill">
              <a
                onClick={this.savePreviewPost}
                href={`/preview/${postdata._id}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fas fa-eye"></i> PC
              </a>
            </DebouncedButton>
            <DebouncedButton className="btn btn-custom ml10 bg-17a2b8 flex-fill">
              <a
                onClick={this.savePreviewPost}
                href={`/preview/${postdata._id}?isMobile=true`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fas fa-eye"></i> Mobile
              </a>
            </DebouncedButton>
          </div>
          )}
        </div>
      );
    } else if (status == "ready") {
      return (
        <div className="action-div">
          {(canPublish || canEditPublish) && (
            <DebouncedButton
              className={
                "btn btn-custom ml10 bg-428bca " +
                (this.props.condition
                  ? "require-status-success"
                  : "require-status-error")
              }
              onClick={() => this.savePost("ready")}
            >
              <i className="fas fa-external-link-square-alt"></i>
              Lưu
            </DebouncedButton>
          )}
          {canTakedown && canPublish && (
            <DebouncedButton
              className="btn btn-custom ml10"
              onClick={() => this.savePost("draft")}
            >
              Gỡ xuống
            </DebouncedButton>
          )}
          {canTrash && (
            <DebouncedButton
              className="btn btn-custom ml10"
              onClick={() => this.actionBeforeConfirm("trash", 'Bạn thực hiện thao tác bỏ rác ?')}
            >
              Bỏ rác
            </DebouncedButton>
          )}
          {true && (
          <div className="d-flex justify-content-center gap-2 mt-2">
            <DebouncedButton className="btn btn-custom ml10 bg-17a2b8 flex-fill">
              <a
                onClick={this.savePreviewPost}
                href={`/preview/${postdata._id}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fas fa-eye"></i> PC
              </a>
            </DebouncedButton>
            <DebouncedButton className="btn btn-custom ml10 bg-17a2b8 flex-fill">
              <a
                onClick={this.savePreviewPost}
                href={`/preview/${postdata._id}?isMobile=true`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fas fa-eye"></i> Mobile
              </a>
            </DebouncedButton>
          </div>
          )}
        </div>
      );
    } else if (status == "schedule") {
      return (
        <div className="action-div">
          {canPublish && (
            <DebouncedButton
              className={
                "btn btn-custom ml10 bg-428bca " +
                (this.props.condition
                  ? "require-status-success"
                  : "require-status-error")
              }
              onClick={() => this.savePost("schedule")}
            >
              <i className="fas fa-external-link-square-alt"></i>
              Lưu
            </DebouncedButton>
          )}
          {canPublish && this.props.condition && !scheduleDate && (
            <DebouncedButton
              className={
                "btn btn-custom ml10 bg-428bca " +
                (this.props.condition
                  ? "require-status-success"
                  : "require-status-error")
              }
              onClick={() => this._publishPost()}
            >
              <i className="fas fa-external-link-square-alt"></i>
              Đăng bài
            </DebouncedButton>
          )}

          {canPublish && this.props.condition && scheduleDate && (
            <DebouncedButton
              className={
                "btn btn-custom ml10 bg-f0ad4e " +
                (this.props.condition
                  ? "require-status-success"
                  : "require-status-error")
              }
              onClick={() => this.savePost("schedule")}
            >
              <i className="fas fa-calendar-day"></i>
              Lên lịch
            </DebouncedButton>
          )}

          {canPublish && (
            <DebouncedButton
              className="btn btn-custom ml10 bg-d9534f"
              onClick={() => this.actionBeforeConfirm("draft", 'Bạn thực hiện thao tác trả bài chờ duyệt ?')}
            >
              <i className="fas fa-times"></i>
              Trả bài
            </DebouncedButton>
          )}
          {countWordsHTML(postdata.content) > this.state.aiLimitWords && <ButtonAi postItem={postdata} className="rounded-1" />}
          {true && (
          <div className="d-flex justify-content-center gap-2">
            <DebouncedButton className="btn btn-custom ml10 bg-17a2b8 flex-fill">
              <a
                onClick={this.savePreviewPost}
                href={`/preview/${postdata._id}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fas fa-eye"></i> PC
              </a>
            </DebouncedButton>
            <DebouncedButton className="btn btn-custom ml10 bg-17a2b8 flex-fill">
              <a
                onClick={this.savePreviewPost}
                href={`/preview/${postdata._id}?isMobile=true`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fas fa-eye"></i> Mobile
              </a>
            </DebouncedButton>
          </div>
          )}
        </div>
      );
    } else {
      return (
        <div className="action-div">
          {/* {canPublish && (
            <DebouncedButton
              className="btn btn-custom ml10 bg-428bca"
              onClick={() => this.savePost("ready")}
            >
              <i className="fas fa-external-link-square-alt"></i>
              Đăng bài
            </DebouncedButton>
          )} */}
          {canReject && (
            <DebouncedButton
              className="btn btn-custom ml10 bg-d9534f"
              onClick={() => this.actionBeforeConfirm("draft", 'Bạn thực hiện thao tác trả bài chờ duyệt ?')}
            >
              <i className="fas fa-times"></i>
              Trả bài
            </DebouncedButton>
          )}
          {goPreview && this.props.condition && this.props.condition && (
            <DebouncedButton
              className={
                "btn btn-custom ml10 bg-12BF6D " +
                (this.props.condition
                  ? "require-status-success"
                  : "require-status-error")
              }
              onClick={() => this.savePost("waiting")}
            >
              <i className="fas fa-paper-plane"></i>
              Gửi Duyệt
            </DebouncedButton>
          )}
          {isDraft && (
            <DebouncedButton
              className="btn btn-custom ml10 bg-FFA52A"
              onClick={() => this.savePost("draft")}
            >
              <i className="fas fa-save"></i>
              Lưu Nháp
            </DebouncedButton>
          )}
          {countWordsHTML(postdata.content) > this.state.aiLimitWords && <ButtonAi postItem={postdata} className="rounded-1" />}
          {true && (
            <>
            <DebouncedButton className="btn btn-custom ml10 bg-17a2b8">
              <a
                onClick={this.savePreviewPost}
                href={`/preview/${postdata._id}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fas fa-eye"></i> Xem thử
              </a>
            </DebouncedButton>
            <DebouncedButton className="btn btn-custom ml10 bg-17a2b8">
              <a
                onClick={this.savePreviewPost}
                href={`/preview/${postdata._id}?isMobile=true`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fas fa-eye"></i> Xem thử Mobi
              </a>
            </DebouncedButton>
            </>
          )}
        </div>
      );
    }
  }

  _publishPost() {
    confirm({
      title: 'Đăng bài viết này ?',
      callbackFunc: () => {
        this.savePost('ready');
      }      
    });
  }

  render() {
    const { postdata, layoutName, condition } = this.props;
    const { listTab } = this.state;
    const popover = (
      <Popover>
        <RequireChecklist isPr={postdata.pr_type > 0 ? true : false} listTab={listTab} layoutName={layoutName} />
        <div className="layout-mobile" style={{ marginTop: "-10px", width: "230px" }}>
          {!this.state.clickingButton &&
            this.generateAction(postdata.posttype.type_code)}
        </div>
      </Popover>
    );

    // console.log('listTab', listTab);
    const listTabPassCondition = _.filter(listTab, { 'error': false, 'isPrerequisite': true });
    const listTabIsPrerequisite = _.filter(listTab, { 'isPrerequisite': true });

    // console.log(passCondition === 9);

    return (
      <>
        {
          <OverlayTrigger
            trigger="click"
            overlay={popover}
            placement="top"
            rootClose={true}
          >
            <DebouncedButton
              className={
                "btn btn-lg rounded-circle text-white fixed-bottom-right " +
                (listTab && listTabPassCondition.length === listTabIsPrerequisite.length ? "bg-success" : "bg-FFA52A")
              }
              style={{
                width: "50px",
                height: "50px"
              }}
            >
              <i className="fas fa-save"></i>
            </DebouncedButton>
          </OverlayTrigger>
        }

      </>
    );
  }
}
export default connect(
  store => {
    return {
      post: store.post,
      config: store.config
    };
  },
  dispatch => {
    return {};
  }
)(ActionsPost);
